/**
 * Toggle the active class on the hamburger
 * Set navigation and navigationActive strings to your used classes
 */
export const initNavigation = function () {
  const hamburger = $('.hamburger');
  const navigation = $('.your-nav-class');
  const navigationActive = 'your-nav-class--active';

  window._currentSectionItem = $('.section-menu__list').find('[data-menuid='+window.current_section+']');
  window._currentSectionItem.addClass('section-menu__item--active');

  $('.main-menu__item-link').on('click',function(){
    $('.main-menu__item--active').removeClass('main-menu__item--current');
    $(this).parent().addClass('main-menu__item--current');
    $('.section-menu__item--active').removeClass('section-menu__item--active');
    $(this).closest('.section-menu__item').addClass('section-menu__item--active');
  });


  hamburger.on('click', () => {
    hamburger.toggleClass('is-active');
    navigation.toggleClass(navigationActive);
    $('.mobile-menu').toggleClass('active');
  });


$('.mobile-menu__item-link').on('click', function (e) {
  e.preventDefault();

  if( $(this).parent().hasClass('current') ){
    $('.mobile-menu__item.current').removeClass('current');
  } else {
    $('.mobile-menu__item.current').removeClass('current');
    $(this).parent().addClass('current');

  }
});

$('.mobile-menu__sub-item.has-children .mobile-menu__sub-item-link').on('click', function (e) {
  e.preventDefault();
  // $(".mobile-menu__sub-item.current").toggleClass("current");
  $(this).parent().toggleClass('current');
});

  $(window).on('scroll', makeSticky);
  makeSticky();

  $('.main-menu__item--has-fold-out').hover(function (e) {
    $('.layout-mask').addClass('layout-mask--active');
    $(this).find('.main-menu-fold-out').addClass('main-menu-fold-out--active');
  }, function (e) {
    $('.layout-mask').removeClass('layout-mask--active');
    $(this).find('.main-menu-fold-out').removeClass('main-menu-fold-out--active');
  });

  const mainMenuID = $('.section-menu__list').data('main-menu-current');
console.log(mainMenuID);
  if (mainMenuID) {
    $('.main-menu__item[data-menu-id=' + mainMenuID + ']').addClass('main-menu__item--current');
  }
};

/**
 * Activate sticky header bar
 */
const makeSticky = function() {
  let gap = 92; //$('.site-header__logo');
  let header = $('.site-header');
  let layout = $('body');
  if ($(window).scrollTop() >= gap /*.outerHeight()*/ ) {
    header.addClass('site-header--is-stuck');
    layout.addClass('is-stuck');
  } else {
    header.removeClass('site-header--is-stuck');
    layout.removeClass('is-stuck');
  }
};
